import React, {Fragment} from 'react';
import {FormControlLabel, Checkbox} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import RegisterForm from '../register/register'
import LoginForm from '../loginForm/loginForm'
import _isEqual from "lodash/isEqual";
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {
    ClockLoader
} from 'react-spinners';

interface OwnProps {
    User?: any,
}

interface MainState {
    haveAccount: boolean,
    loggedIn: boolean,
    user: any,
    loading: boolean
}

interface ConnectStateProps {
    User?: any,
}

interface ConnectDispatchProps {
}

type HeaderProps = OwnProps

class UserForm extends React.Component<HeaderProps, MainState> {
    state = {
        haveAccount: false,
        loggedIn: false,
        loading: true,
        user: {
            first_name: ''
        },
    };

    async componentDidMount() {
        const {User} = this.props;
        if (Object.keys(User).length) {
            await this.setState({user: User, loggedIn: true});
        }
        setTimeout(() => {
            this.setState({loading: false})
        }, 500)
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {User} = props;
        if (Object.keys(User).length && (!_isEqual(state.user, User))) {
            return {
                user: User,
                loggedIn: true,
            }
        }
        return null;
    }


    render() {
        const {haveAccount, loggedIn, loading, user} = this.state;
        return (
            <Fragment>
                {loading ? <div
                    className="d-flex align-items-center justify-content-center">
                    <ClockLoader color={'var(--primary)'} loading={true}/>
                </div> : <Fragment>
                    {!loggedIn && <FormControlLabel
                        control={
                            <Checkbox
                                checked={haveAccount}
                                onChange={() => this.setState({haveAccount: !haveAccount})}
                                value="checked"
                            />
                        }
                        label="I have an account"
                    />}
                    {loggedIn ? <MuiAlert style={{marginTop: '20px'}} className="mb-4" severity="success">
                        <div className="d-flex align-items-center align-content-center">
                          <span style={{color: '#0A501A',fontSize: '14px'}}>
                            <strong className="d-block">Welcome back {user?.first_name}!</strong>
                              You have successfully logged in.
                          </span>
                        </div>
                    </MuiAlert> : haveAccount ? <LoginForm embedded={true}/> : <RegisterForm/>}
                </Fragment>}

            </Fragment>
        )
    }
}


type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User} = state;
    return {
        User
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
